<template>
  <a href="#" class="conversation-card" @click.prevent="$emit('click')">
    <img class="avatar" :src="avatar" alt="avatar" />
    <div class="card-content">
      <div class="card-title-row">
        <span class="card-title">{{ conversationTitle }}</span>
      </div>
      <div class="card-subtitle">
        {{ assistantTitle }} - {{ relativeDate }}
        <span v-if="conversation.isConversationActive" class="badge">{{ $t('conversation_hub.badge_active') }}</span>
      </div>
      <div class="card-date"></div>
    </div>
    <i class="fas fa-chevron-right" aria-hidden="true"></i>
  </a>
</template>

<script>
// Style
import '../../assets/styles/conversationHub.css'

// Utils
import { getRelativeTime } from '../../lib/utils'

export default {
  name: 'ConversationCard',
  props: {
    conversation: { type: Object, required: true },
    index: { type: Number, required: true },
    avatar: { type: String, required: true },
    assistantTitle: { type: String, required: true }
  },
  computed: {
    conversationTitle() {
      if (this.conversation.isConversationActive) {
        return this.$t('conversation_hub.conversation_in_progress')
      }
      return this.conversation.conversationTitle || this.$t('conversation_hub.conversation_ended')
    },
    relativeDate() {
      return getRelativeTime(this.conversation.endTime, this.conversation.platformLocale)
    }
  }
}
</script>
